<template>
  <transition name="fade">
  <div class="question quesiton-number box box-shadow">

    <div class="question--question" v-html="question"></div>

    <div class="answers">
          <date-picker 
            v-bind:value="value"
            v-on:input="$emit('input', $event)"
            :not-after="new Date()" 
            :first-day-of-week="1" 
            lang="en" 
            format="DD/MM/YYYY"
            input-class="form-control"></date-picker>
    </div>

    <footer>Q ID: {{id}} : {{index}}</footer>

  </div>
  </transition>
</template>

<script>
import Question from '@/components/questions/Question'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'Date',
  components: { DatePicker },
  extends: Question
}
</script>

<style scoped>
  .mx-datepicker{
    /*margin: 2rem auto 0 !important;*/
    display: block !important;
  }
</style>
 


// WEBPACK FOOTER //
// src/components/questions/Date.vue